module.exports = __webpack_public_path__ + "img/slide2.d92bd65f.jpg";